import { render, staticRenderFns } from "./StatusTransitions.vue?vue&type=template&id=183697ba&scoped=true"
import script from "./StatusTransitions.vue?vue&type=script&lang=js"
export * from "./StatusTransitions.vue?vue&type=script&lang=js"
import style0 from "./StatusTransitions.vue?vue&type=style&index=0&id=183697ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183697ba",
  null
  
)

export default component.exports